import React, { useEffect } from "react";
import { Control, FieldErrors } from "react-hook-form";
import { FormTextField } from "sprint-common-web";

import { subtitlesTargetFileNameTokens } from "../../../../common/utils/tokens/subtitlesTargetFileNameTokens";
import { validateSubtitlesTargetFileName } from "../../../../common/utils/validateSubtitlesTargetFileName";
import { SystemPlatform } from "../../../common/types/OrdersAirline";
import { useCreateOrder } from "../common/provider/useCreateOrder";

interface SubtitlesTargetFileNameInputProps {
    name: string;
    label: string;
    dependsOn: string[];
    control: Control;
    errors: FieldErrors;
}

export const SubtitlesTargetFileNameInput: React.FC<SubtitlesTargetFileNameInputProps> = ({
    name,
    label,
    dependsOn,
    control,
    errors
}: SubtitlesTargetFileNameInputProps) => {
    const { system, airline } = useCreateOrder();

    useEffect(() => {
        if (system && airline) {
            const systemPlatform = airline.systemPlatforms.find((item: SystemPlatform) => item.system.id === system.id);

            control.setValue(name, systemPlatform?.subtitlesTargetFileName ?? "");
        } else {
            control.setValue(name, "");
        }
    }, [system, airline]);

    return (
        <FormTextField
            label={label}
            name={name}
            control={control}
            errors={errors}
            disabled={!system}
            dependsOn={dependsOn}
            rules={{
                validate: validateSubtitlesTargetFileName
            }}
            tooltipContent={`Available tokens: ${subtitlesTargetFileNameTokens.join(", ")}`}
        />
    );
};
